import React, { useState } from "react";
import styled from "styled-components";
import {
    CardTableEmptyState,
    DataTable,
    DataTableCell,
    DataTableContainer,
    DataTableHeaderCell,
    DataTableRow
} from "src/components";

import DownArrow from "src/img/arrow-down-sign-to-navigate.svg";
import RightArrow from "src/img/SettingsRightArrow.svg";
import MoreMenuContainer from "./MoreMenuContainer";

const StatementHeaderCell = styled(DataTableCell)`
    height: 52px;
    background: #F3F5FB;
    color: #171A22;
    font-size: 0.95rem;
    font-weight: 800;
`;

const StatementToggleCell = styled(StatementHeaderCell)`
    text-align: center;
    width: 4rem;
`;

const ToggleButton = styled.button`
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: #FFFFFF;
    border: 1px solid #C9D2E7;
    border-radius: 8px;
    cursor: pointer;

    img {
        width: 16px;
        height: 16px;
    }

    &:focus-visible {
        outline: 2px solid #171A22;
        outline-offset: 2px;
    }
`;

const InvoiceText = styled.span`
    color: #5A2A7F;
    font-weight: 800;
`;

const StatusText = styled.span`
    color: ${p => p.$paid ? "#228B19" : "#171A22"};
    font-weight: 800;
`;

function RenewalCommissionTable(props) {
    const earnings = props.earnings || [];
    const token = props.token;
    
    const [selectedIndex, setSelectedIndex] = useState(0);
    
    const renderedLicenseMonthlyEarnings = (licenseEarnings) => {
        const flatEarnings = licenseEarnings.flat();
        const groupedByMonth = flatEarnings.reduce((acc, earning) => {
            if (!acc[earning.name]) acc[earning.name] = [];
            acc[earning.name].push(earning);
            return acc;
        }, {});

        return (
            <>
                {Object.entries(groupedByMonth).map(([month, earningsInMonth], monthIndex) => (
                    <React.Fragment key={monthIndex}>
                 
                        {earningsInMonth.map((earning, idx) => (
                            <DataTableRow
                                key={earning.uuid}
                            >
                                <DataTableCell>{earning.name}</DataTableCell>
                                <DataTableCell>
                                    <InvoiceText>{earning.invoiceNo || ""}</InvoiceText>
                                </DataTableCell>
                                <DataTableCell whiteSpace="normal">{earning.description}</DataTableCell>
                                <DataTableCell>{earning.numberOfRenewal}</DataTableCell>
                                <DataTableCell>
                                    {earning.totalValue ? `${earning.currency} ${earning.totalValue}` : `${earning.currency} 0.00`}
                                </DataTableCell>
                                <DataTableCell>{earning.earningPercent}</DataTableCell>
                                <DataTableCell>
                                    {`${earning.currency} ${earning.totalEarnings ?? "0.00"}`}
                                </DataTableCell>
                                <DataTableCell>
                                    <StatusText $paid={earning.isPaid}>{earning.isPaid ? "PAID" : "PENDING"}</StatusText>
                                </DataTableCell>
                                <DataTableCell textAlign="center" $last>
                                    <MoreMenuContainer earning={earning} token={token} />
                                </DataTableCell>
                            </DataTableRow>
                        ))}
                    </React.Fragment>
                ))}
            </>
        );
    };

    const renderedStatementTBody = earnings.map((value, index) => {
        const heading = value.year;
        const licenseEarnings = value.licenseEarnings;

        return (
            <tbody key={"statement_" + index}>
                <DataTableRow>
                    <StatementHeaderCell colSpan="8">{heading} Statements</StatementHeaderCell>
                    <StatementToggleCell $last>
                        <ToggleButton
                            type="button"
                            onClick={() => setSelectedIndex(selectedIndex === index ? -1 : index)}
                            aria-label={`${selectedIndex === index ? "Collapse" : "Expand"} ${heading} statements`}
                        >
                            <img
                                src={selectedIndex === index ? DownArrow : RightArrow}
                                alt=""
                            />
                        </ToggleButton>
                    </StatementToggleCell>
                </DataTableRow>
                {selectedIndex === index && renderedLicenseMonthlyEarnings(licenseEarnings)}
            </tbody>
        );
    });

    if (!earnings.length) {
        return (
            <CardTableEmptyState minHeight="12rem">
                No earnings statements are available yet.
            </CardTableEmptyState>
        );
    }

    return (
        <DataTableContainer minHeight="0" maxHeight="42rem">
            <DataTable minWidth="1080px" minHeight="0">
                <thead>
                    <tr>
                        <DataTableHeaderCell>Date</DataTableHeaderCell>
                        <DataTableHeaderCell>Invoice/Statement</DataTableHeaderCell>
                        <DataTableHeaderCell>Description</DataTableHeaderCell>
                        <DataTableHeaderCell>Total Licenses</DataTableHeaderCell>
                        <DataTableHeaderCell>Total Paid Amount</DataTableHeaderCell>
                        <DataTableHeaderCell>Earnings/Share %</DataTableHeaderCell>
                        <DataTableHeaderCell>Payout Amount</DataTableHeaderCell>
                        <DataTableHeaderCell>Payout Status</DataTableHeaderCell>
                        <DataTableHeaderCell textAlign="center">&nbsp;</DataTableHeaderCell>
                    </tr>
                </thead>
                {renderedStatementTBody}
            </DataTable>
        </DataTableContainer>
    );
}

export default RenewalCommissionTable;
